import React from "react";
import { Brightness1Icon, CircleOutlineIcon } from "mdi-react";
import { Container, Row, Card, CardBody, Table } from "reactstrap";
import { actionsAvailable } from "../mockdata";
import Modal from "../../../shared/modal";
import * as roles from "../../../shared/service/roles";
const colorByLength = {
  0: "#62cc6e",
  1: "#f2c127",
  2: "#ea802a",
  3: "#e63a5e",
  default: "#eeeeee",
  edit: "#999",
};

class TransactionsCommon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      currentRole: {},
      permissions: [],
    };
  }

  componentDidMount() {
    this.getRole(this.props.rid);
  }

  getRole(rid) {
    roles.get(rid).then(
      (response) => {
        let currentRole = {
          rid: rid,
          role: response.data.role,
          permissions: response.data.permissions,
        };
        this.setState({ currentRole }, () => {
          this.getPermissions();
        });
      },
      (error) => {
        console.error(error);
      }
    );
  }

  getPermissions = () => {
    roles.getPermissions().then(
      (response) => {
        this.setState({ permissions: response.data }, () => {
          this.setPermissions();
        });
      },
      (error) => {
        console.error(error);
      }
    );
  };

  savePermissions = () => {
    roles
      .savePermissions(
        this.state.currentRole.rid,
        this.state.currentRole.role,
        this.state.permissions
      )
      .then(
        (response) => {
          this.setState({
            show: true,
            errors: [],
            success: response._user_message,
          });
        },
        (error) => {
          this.setState({ show: true, errors: error._user_message });
        }
      );
  };

  setPermissions = () => {
    let permissions = [];
    this.state.permissions.forEach((permission) => {
      this.state.currentRole.permissions.forEach((rolePermission) => {
        if (permission.pid === rolePermission.pid) {
          permission.get = rolePermission.get;
          permission.post = rolePermission.post;
          permission.put = rolePermission.put;
          permission.delete = rolePermission.delete;
        }
      });
      permission.get = permission.get !== undefined ? permission.get : 0;
      permission.post = permission.post !== undefined ? permission.post : 0;
      permission.put = permission.put !== undefined ? permission.put : 0;
      permission.delete =
        permission.delete !== undefined ? permission.delete : 0;

      permissions.push(permission);
    });

    this.setState({ permissions });
  };

  togglePermission = (pid, method) => {
    let permissions = [];

    this.state.permissions.forEach((permission) => {
      if (permission.pid === pid) {
        permission[method] = permission[method] === 1 ? 0 : 1;
      }
      permissions.push(permission);
    });

    this.setState({ permissions });
  };

  showModal = (e) => {
    this.setState({
      show: !this.state.show,
    });
  };

  render() {
    return (
      <Container>
        <Row className="user-section">
          <Card className="permissions">
            <CardBody className="">
              <div className="card__title">
                <h5 className="bold-text">
                  Manage Permissions : {this.state.currentRole.role}
                </h5>
                <div className="toolbar-buttons">
                  <button
                    type="button"
                    onClick={() => {
                      this.savePermissions();
                    }}
                    className="btn btn-sm btn-primary"
                  >
                    Update
                  </button>
                </div>
              </div>
              <Table responsive>
                <thead>
                  <th>Permission</th>
                  {actionsAvailable.map((roleOfUser) => (
                    <th key={roleOfUser.title} className="textCenter">
                      <div>
                        <div className="rolename">{roleOfUser.title}</div>
                      </div>
                    </th>
                  ))}
                </thead>
                <tbody>
                  {this.state.permissions.map((permission) => (
                    <tr key={permission.pid}>
                      <td>{permission.permission}</td>
                      <td className="tc">
                        {permission.get ? (
                          <Brightness1Icon
                            color={colorByLength["0"]}
                            size="10"
                            onClick={() => {
                              this.togglePermission(permission.pid, "get");
                            }}
                          />
                        ) : (
                          <CircleOutlineIcon
                            color={colorByLength["3"]}
                            size="10"
                            onClick={() => {
                              this.togglePermission(permission.pid, "get");
                            }}
                          />
                        )}
                      </td>
                      <td className="tc">
                        {permission.post ? (
                          <Brightness1Icon
                            color={colorByLength["0"]}
                            size="10"
                            onClick={() => {
                              this.togglePermission(permission.pid, "post");
                            }}
                          />
                        ) : (
                          <CircleOutlineIcon
                            color={colorByLength["3"]}
                            size="10"
                            onClick={() => {
                              this.togglePermission(permission.pid, "post");
                            }}
                          />
                        )}
                      </td>
                      <td className="tc">
                        {permission.put ? (
                          <Brightness1Icon
                            color={colorByLength["0"]}
                            size="10"
                            onClick={() => {
                              this.togglePermission(permission.pid, "put");
                            }}
                          />
                        ) : (
                          <CircleOutlineIcon
                            color={colorByLength["3"]}
                            size="10"
                            onClick={() => {
                              this.togglePermission(permission.pid, "put");
                            }}
                          />
                        )}
                      </td>
                      <td className="tc">
                        {permission.delete ? (
                          <Brightness1Icon
                            color={colorByLength["0"]}
                            size="10"
                            onClick={() => {
                              this.togglePermission(permission.pid, "delete");
                            }}
                          />
                        ) : (
                          <CircleOutlineIcon
                            color={colorByLength["3"]}
                            size="10"
                            onClick={() => {
                              this.togglePermission(permission.pid, "delete");
                            }}
                          />
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Row>
        <Modal
          onClose={this.showModal}
          show={this.state.show}
          errors={this.state.errors}
          success={this.state.success}
        ></Modal>
      </Container>
    );
  }
}

export default TransactionsCommon;
